import React, { FC, FunctionComponent, SVGProps } from "react";
import { Link } from "react-router-dom"
import { MenuItem } from "@mui/material"

import { handleMenuItemStyle, sideMenuItem } from "../headerMenuStyles"

type IconMenuItem = {
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>
  alt: {
    ru: string
    en: string
  }
  path?: string
  text?: string
}

export type HeaderItemProps = {
  item: IconMenuItem
  i: number
  isOpenMenu: boolean
}



const HeaderItem: FC<HeaderItemProps> = ({ item, i, isOpenMenu }) => {
  const { path, icon: Icon, text } = item || {}

  if (!path || !Icon || !text) {
    return null
  }

  return (
    <Link to={path} key={text} style={handleMenuItemStyle(i, isOpenMenu)}>
      <MenuItem sx={sideMenuItem}>
        <Icon/>
        {text}
      </MenuItem>
    </Link>
  )
}

export default HeaderItem
